import { render } from "./PasswordResetSuccess.vue?vue&type=template&id=6b0d48d4&scoped=true&ts=true"
import script from "./PasswordResetSuccess.vue?vue&type=script&lang=ts"
export * from "./PasswordResetSuccess.vue?vue&type=script&lang=ts"

import "./PasswordResetSuccess.vue?vue&type=style&index=0&id=6b0d48d4&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0d48d4"]])

export default __exports__